import { jsx } from 'react/jsx-runtime';
import { makeStyles } from '@material-ui/core/styles';
import { EntityLifecycleFilter } from '../../filters.esm.js';
import { EntityAutocompletePicker } from '../EntityAutocompletePicker/EntityAutocompletePicker.esm.js';
import { catalogReactTranslationRef } from '../../translation.esm.js';
import { useTranslationRef } from '@backstage/core-plugin-api/alpha';

const useStyles = makeStyles(
  {
    input: {}
  },
  { name: "CatalogReactEntityLifecyclePicker" }
);
const EntityLifecyclePicker = (props) => {
  const { initialFilter = [] } = props;
  const classes = useStyles();
  const { t } = useTranslationRef(catalogReactTranslationRef);
  return /* @__PURE__ */ jsx(
    EntityAutocompletePicker,
    {
      label: t("entityLifecyclePicker.title"),
      name: "lifecycles",
      path: "spec.lifecycle",
      Filter: EntityLifecycleFilter,
      InputProps: { className: classes.input },
      initialSelectedOptions: initialFilter
    }
  );
};

export { EntityLifecyclePicker };
//# sourceMappingURL=EntityLifecyclePicker.esm.js.map
